import { formatValue } from '@/utils';
import dayjs from 'dayjs';
export const getHandleData = (total, t)=>[
        /** 转化率-试用前 */ {
            label: t('c_a_ai_before_is_trial'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.before_conversion_rate, '%'),
            tooltip: t('c_a_ai_before_is_trial_tips')
        },
        /** 转化率-试用后 */ {
            label: t('c_a_ai_after_the_trial'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.after_conversion_rate, '%'),
            tooltip: t('c_a_ai_after_the_trial_tips')
        },
        /** 转化率提升 */ {
            label: t('c_a_ai_rate_improvement'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.conversion_growth_rate, '%'),
            tooltip: t('c_a_ai_conversion_enhance_tips')
        },
        /** 咨询占比 */ {
            label: t('c_a_ai_consultation_proportion'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.consult_rate, '%'),
            tooltip: t('c_a_ai_rate_improvement_tips')
        }
    ];
/** 添加自定义数据 */ export const getWeekList = (list, t)=>{
    var _list_filter;
    let beforeCount = 0;
    let afterCount = 0;
    const beforeTotal = list === null || list === void 0 ? void 0 : (_list_filter = list.filter((item)=>item.type == 'before')) === null || _list_filter === void 0 ? void 0 : _list_filter.length;
    return list === null || list === void 0 ? void 0 : list.map((item)=>{
        if (item.type === 'before') {
            beforeCount++;
            const num = beforeTotal - beforeCount + 1;
            return {
                ...item,
                week_label: t('c_a_ai_chart_week_before', {
                    Num: num
                })
            };
        } else {
            afterCount++;
            const num = afterCount;
            return {
                ...item,
                week_label: t('c_a_ai_chart_week_after', {
                    Num: num
                })
            };
        }
    });
};
export const getOptionList = (weekList, t)=>{
    /** x轴的Label自定义显示 */ const xAxisData = weekList === null || weekList === void 0 ? void 0 : weekList.map((item)=>item.week_label);
    /** 对应系列数据 */ const gmvOrigin = weekList === null || weekList === void 0 ? void 0 : weekList.map((item)=>item.conversion_gmv);
    const gmvGrowth = weekList === null || weekList === void 0 ? void 0 : weekList.map((item)=>item.gmv_growth || 0);
    const conversionRate = weekList === null || weekList === void 0 ? void 0 : weekList.map((item)=>parseFloat(item.conversion_rate));
    return {
        tooltip: {
            trigger: 'axis',
            backgroundColor: '#fff',
            borderColor: '#ddd',
            borderWidth: 1,
            textStyle: {
                color: '#333'
            },
            formatter: (params)=>{
                const { axisValue } = params[0];
                const item = weekList.find((i)=>i.week_label === axisValue);
                if (!item) return '';
                const conversionRateStr = parseFloat(String(item.conversion_rate) || '0').toFixed(2);
                const gmvOriginStr = formatValue(item.conversion_gmv);
                const gmvGrowthStr = formatValue(item.gmv_growth || 0);
                const weekNum = Number(item.week_label.replace(/[^\d]/g, ''));
                const timeInterval = item.type === 'before' ? `${t('c_a_ai_original_week_before', {
                    num: weekNum
                })} ` : `${t('c_a_ai_original_week_after', {
                    num: weekNum
                })}`;
                return `
					<div style="padding:6px 12px; line-height:1.6;">
						<div style="font-weight:600; margin-bottom:8px; font-size:14px;">${axisValue}</div>
						<div style="margin-bottom:4px;">${timeInterval}：${dayjs(item.start_date).format('YYYY.MM.DD')} ～ ${dayjs(item.end_date).format('YYYY.MM.DD')}</div>
						<div style="margin-bottom:4px;">${t('c_a_ai_conversion_rate')}：${conversionRateStr}%</div>
						<div style="margin-bottom:4px;">${t('c_a_ai_original_gmv')}：${gmvOriginStr}</div>
						<div>${t('c_a_ai_gmv_increment')}：${gmvGrowthStr}</div>
					</div>
				`;
            }
        },
        legend: {
            bottom: 6,
            left: 'center',
            textStyle: {
                fontSize: 12,
                color: '#000'
            }
        },
        grid: {
            left: 10,
            right: 10,
            bottom: 50,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: xAxisData
        },
        yAxis: [
            {
                type: 'value',
                min: 0,
                position: 'left',
                axisLabel: {
                    formatter: '{value}'
                },
                splitLine: {
                    show: false
                }
            },
            {
                type: 'value',
                min: 0,
                position: 'right',
                axisLabel: {
                    formatter: '{value}'
                }
            }
        ],
        barCategoryGap: '20%',
        barGap: '0%',
        series: [
            /** 原GMV￥(预估) */ {
                name: t('c_a_ai_original_gmv'),
                type: 'bar',
                stack: 'duration' /** 堆叠 */ ,
                data: gmvOrigin,
                yAxisIndex: 1,
                barWidth: 36,
                itemStyle: {
                    color: '#9AA2CA'
                }
            },
            /** GMV增量￥ */ {
                name: t('c_a_ai_gmv_increment'),
                type: 'bar',
                stack: 'duration' /** 堆叠 */ ,
                data: gmvGrowth,
                yAxisIndex: 1,
                barWidth: 36,
                itemStyle: {
                    color: '#ffb72b'
                }
            },
            /** 下单转化率 */ {
                name: t('c_a_ai_order_conversion_rate'),
                type: 'line',
                data: conversionRate,
                yAxisIndex: 0,
                tooltip: {
                    valueFormatter: function(value) {
                        return value;
                    }
                },
                label: {
                    show: true,
                    position: 'top',
                    align: 'center',
                    verticalAlign: 'bottom',
                    formatter: (params)=>{
                        const value = params.value;
                        if (value === null || value === undefined || isNaN(value)) return '';
                        return value.toFixed(2) + '%';
                    }
                }
            }
        ]
    };
};
